import React from 'react'

const Privacy = () => {
  return (
    <div className="container py-4">
      <h1 className="fw-bold mb-4">
        Политика в отношении обработки и передачи персональных данных в CRM-системе
        https://kanepro.ru/
      </h1>

      <p className="text-muted mb-4">01 марта 2026 г.</p>

      <h3 className="fw-bold mt-4">1. Термины и определения</h3>
      <p>
        1.1. Персональные данные - любая информация, относящаяся прямо или косвенно к определенному
        или определяемому физическому лицу (субъекту персональных данных).
      </p>
      <p>
        1.2. Субъект персональных данных - физическое лицо, к которому относятся персональные
        данные.
      </p>
      <p>
        1.3. Оператор - лицо, самостоятельно или совместно с другими лицами организующее и (или)
        осуществляющее обработку персональных данных.
      </p>
      <p>
        1.4. Обработка персональных данных - любое действие (операция) или совокупность действий,
        совершаемых с персональными данными, включая сбор, запись, систематизацию, накопление,
        хранение, уточнение (обновление, изменение), извлечение, использование, передачу
        (предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных
        данных.
      </p>
      <p>
        1.5. CRM-система KANE PRO https://kanepro.ru/ - информационная система, используемая
        Оператором для учета взаимодействия с клиентами, хранения данных, автоматизации продаж и
        бизнес-процессов.
      </p>
      <p>
        1.6. Трансграничная передача персональных данных - передача персональных данных на
        территорию иностранного государства.
      </p>
      <p>
        1.7. Уничтожение персональных данных - действия, в результате которых становится невозможным
        восстановление персональных данных.
      </p>

      <h3 className="fw-bold mt-4">2. Общие положения</h3>
      <p>
        2.1. Настоящая Политика определяет порядок обработки и передачи персональных данных в
        CRM-системе KANE PRO https://kanepro.ru/ .
      </p>
      <p>2.2. Политика разработана в соответствии с:</p>
      <ul>
        <li>Конституцией Российской Федерации;</li>
        <li>Федеральным законом №152-ФЗ «О персональных данных»;</li>
        <li>иными нормативными правовыми актами Российской Федерации.</li>
      </ul>
      <p>
        2.3. Оператором персональных данных является:
        <br />
        Общество с ограниченной ответственностью Научно-производственное объединение «ЛАБКОСМЕТИК»
        <br />
        ОГРН: 1247800062883, ИНН: 7814840266, КПП: 781401001,
        <br />
        Юридический адрес: 197374, г. Санкт-Петербург, Мебельная ул., д. 12, к. 1, литера А, помещ.
        55-н/оф №417-4
      </p>
      <p>
        2.4. Политика распространяется на все персональные данные, обрабатываемые в CRM-системе.
      </p>
      <p>2.5. Политика применяется к следующим категориям субъектов:</p>
      <ul>
        <li>клиенты;</li>
        <li>потенциальные клиенты;</li>
        <li>контрагенты;</li>
        <li>представители юридических лиц;</li>
        <li>иные лица, взаимодействующие с Оператором через CRM.</li>
      </ul>
      <p>2.6. Согласие на обработку персональных данных предоставляется субъектом путем:</p>
      <ul>
        <li>заполнения форм;</li>
        <li>передачи данных менеджеру;</li>
        <li>совершения действий, свидетельствующих о намерении взаимодействовать с Оператором.</li>
      </ul>

      <h3 className="fw-bold mt-4">3. Перечень действий с персональными данными</h3>
      <p>
        3.1. Оператор осуществляет: сбор, запись, систематизацию, накопление, хранение, уточнение,
        извлечение, использование, передачу, обезличивание, блокирование, удаление и уничтожение
        персональных данных.
      </p>
      <p>3.2. Обработка осуществляется:</p>
      <ul>
        <li>автоматизированным способом (в CRM);</li>
        <li>неавтоматизированным способом;</li>
        <li>смешанным способом.</li>
      </ul>

      <h4 className="fw-bold mt-3">3.4. Передача персональных данных третьим лицам</h4>
      <p>
        3.4.1. В целях, указанных в разделе 4 настоящей Политики, Оператор вправе передавать
        персональные данные субъектов третьим лицам при наличии согласия субъекта либо в случаях,
        предусмотренных законодательством РФ.
      </p>
      <p>
        3.4.2. Передача осуществляется в объеме, необходимом для достижения целей обработки, с
        соблюдением требований законодательства Российской Федерации.
      </p>
      <p>3.4.3. Персональные данные могут передаваться:</p>
      <ul>
        <li>
          <strong>Сотрудникам Оператора</strong> — исключительно в рамках исполнения должностных
          обязанностей.
        </li>
        <li>
          <strong>Подрядчикам и исполнителям</strong> — для обеспечения деятельности (маркетинг, IT,
          обработка заявок, коммуникации), на основании договоров.
        </li>
        <li>
          <strong>Аффилированным лицам и компаниям бренда KANE</strong> — в целях обеспечения единых
          бизнес-процессов.
        </li>
        <li>
          <strong>Конкретные третьи лица:</strong>
          <ul className="mt-2">
            <li>
              ООО «ЯНДЕКС», ИНН 7736207543, КПП 770401001, ОГРН 1027700229193, Адрес: 119021, г.
              Москва, ул. Льва Толстого, д. 16
            </li>
            <li>
              ООО «1С-Битрикс», ИНН 7717586110, КПП 770501001, ОГРН 5077746476209, Адрес: 109544, г.
              Москва, б-р Энтузиастов, д. 2, этаж 13
            </li>
            <li>
              ООО «ИНТРАСТ», ИНН 2457064342, КПП 780201001, ОГРН 1072457003860, Адрес: 194100, г.
              Санкт-Петербург, ул. Грибалёвой, д. 7
            </li>
            <li>
              АО «ИОТ», ИНН 7731399513, КПП 773101001, ОГРН 1187746221860, Адрес: 121205, г. Москва,
              Сколково, д. 42
            </li>
            <li>
              АО «АМОЦРМ», ИНН 7709477879, КПП 770501001, ОГРН 5157746087681, Адрес: 115093, г.
              Москва, ул. Люсиновская, д. 38
            </li>
            <li>
              ООО «СМС.РУ», ИНН 7713461582, КПП 771301001, ОГРН 1187746809007, Адрес: 127422, г.
              Москва, ул. Тимирязевская, д. 5/14
            </li>
            <li>
              ИП Кудрина Евгения Васильевна, ИНН 781711180585, ОГРН 323784700331009, Адрес: г.
              Санкт-Петербург, г. Колпино, ул. Веры Слуцкой, д. 32
            </li>
          </ul>
        </li>
      </ul>
      <p>3.4.4. Передача осуществляется:</p>
      <ul>
        <li>на основании договоров;</li>
        <li>либо при наличии самостоятельных правовых оснований у получателя данных.</li>
      </ul>
      <p>3.4.5. Оператор требует от всех лиц, получающих данные:</p>
      <ul>
        <li>соблюдения конфиденциальности;</li>
        <li>использования данных только по назначению;</li>
        <li>соблюдения законодательства РФ.</li>
      </ul>

      <h3 className="fw-bold mt-4">4. Цели обработки персональных данных</h3>
      <p>4.1. Обработка осуществляется в целях:</p>
      <ul>
        <li>ведения клиентской базы;</li>
        <li>обработки заявок;</li>
        <li>заключения и исполнения договоров;</li>
        <li>взаимодействия с клиентами;</li>
        <li>аналитики и улучшения процессов;</li>
        <li>маркетинговых рассылок (при согласии);</li>
        <li>соблюдения законодательства РФ;</li>
        <li>
          продвижения на рынке товаров, работ, услуг, в том числе путем осуществления рекламных
          рассылок, уведомлений Оператором субъекта персональных данных о новых продуктах и
          услугах/работах, специальных предложениях и мероприятиях, посредством отправки электронных
          писем на адрес электронной почты и sms-сообщений на телефонный номер (при наличии
          соответствующего отдельного согласия Субъекта на это), в том числе информирование
          Пользователя посредством отправки электронных писем, sms-рассылок и рассылок в
          мессенджерах. При этом субъект персональных данных в любое время может отказаться от
          получения такой информации, направив Оператору письмо на электронную почту:{' '}
          <a href="mailto:info@labcosmetic.ru">info@labcosmetic.ru</a> с пометкой «Отказ от
          информационной и рекламной рассылки»;
        </li>
        <li>
          сбора отзывов и комментариев субъекта персональных данных относительно услуг Оператора.
        </li>
      </ul>

      <h3 className="fw-bold mt-4">5. Категории персональных данных</h3>
      <p>Оператор обрабатывает:</p>
      <ul>
        <li>ФИО;</li>
        <li>телефон;</li>
        <li>email;</li>
        <li>должность и компания;</li>
        <li>история взаимодействия;</li>
        <li>записи звонков;</li>
        <li>переписка;</li>
        <li>дата, месяц, год рождения;</li>
        <li>пол;</li>
        <li>
          паспортные данные и/или данные иных документов, позволяющих идентифицировать личность
          Клиента;
        </li>
        <li>адрес регистрации;</li>
        <li>ИНН;</li>
        <li>СНИЛС;</li>
        <li>банковские реквизиты;</li>
        <li>
          технические сведения о пользовательских устройствах и идентификаторы, в т.ч. файлы
          cookies, в т.ч. с помощью сервиса веб-аналитики Яндекс Метрика, информация о
          пользовательском местоположении, сведения о приобретенных товарах (услугах) и иные данные,
          самостоятельно предоставленные такими пользователями в адрес Оператора (в отношении
          пользователей и иных онлайн-сервисов Оператора);
        </li>
        <li>данные о заказах.</li>
      </ul>

      <h3 className="fw-bold mt-4">6. Принципы обработки персональных данных</h3>
      <p>
        6.1. Обработка персональных данных Оператором осуществляется с учетом необходимости
        обеспечения защиты прав и свобод субъектов персональных данных, в том числе защиты права на
        неприкосновенность частной жизни, личную и семейную тайну, на основе следующих принципов:
      </p>
      <ul>
        <li>обработке подлежат только персональные данные, которые отвечают целям их обработки;</li>
        <li>
          не допускается обработка персональных данных, несовместимая с целями сбора персональных
          данных;
        </li>
        <li>
          не допускается объединение баз данных, содержащих персональные данные, обработка которых
          осуществляется в целях, несовместимых между собой;
        </li>
        <li>
          содержание и объем обрабатываемых персональных данных соответствует заявленным целям
          обработки;
        </li>
        <li>
          не допускается избыточность обрабатываемых персональных данных по отношению к заявленным
          целям их обработки;
        </li>
        <li>
          при обработке персональных данных обеспечивается точность персональных данных, их
          достаточность, а в необходимых случаях и актуальность по отношению к заявленным целям их
          обработки;
        </li>
        <li>
          хранение персональных данных осуществляется в форме, позволяющей определить субъекта
          персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если
          срок хранения персональных данных не установлен федеральным законом либо договором,
          стороной, выгодоприобретателем или поручителем, по которому является субъект персональных
          данных;
        </li>
        <li>
          обрабатываемые персональные данные уничтожаются либо обезличиваются по достижении целей
          обработки или в случае утраты необходимости в достижении этих целей, если иное не
          предусмотрено федеральным законом.
        </li>
      </ul>

      <h3 className="fw-bold mt-4">7. Условия обработки и хранения</h3>
      <p>7.1. Обработка осуществляется на территории РФ.</p>
      <p>7.2. Данные хранятся:</p>
      <ul>
        <li>до достижения целей обработки;</li>
        <li>либо до отзыва согласия.</li>
      </ul>
      <p>7.3. После достижения целей данные подлежат уничтожению или обезличиванию.</p>

      <h3 className="fw-bold mt-4">8. Меры по обеспечению безопасности персональных данных</h3>
      <p>
        8.1. Оператор принимает необходимые правовые, организационные и технические меры для защиты
        персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения,
        блокирования, распространения и других несанкционированных действий, в том числе:
      </p>
      <ul>
        <li>определяет угрозы безопасности персональных данных при их обработке;</li>
        <li>
          принимает локальные нормативные акты и иные документы, регулирующие отношения в сфере
          обработки и защиты персональных данных;
        </li>
        <li>назначает лиц, ответственных за обеспечение безопасности персональных данных;</li>
        <li>создает необходимые условия для работы с персональными данными;</li>
        <li>организует учет документов, содержащих персональные данные;</li>
        <li>
          организует работу с информационными системами, в которых обрабатываются персональные
          данные;
        </li>
        <li>
          хранит персональные данные в условиях, при которых обеспечивается их сохранность и
          исключается неправомерный доступ к ним;
        </li>
        <li>
          организует обучение работников Оператора, осуществляющих обработку персональных данных.
        </li>
      </ul>

      <h3 className="fw-bold mt-4">9. Права субъекта персональных данных</h3>
      <p>9.1. Субъекты персональных данных имеют право на:</p>
      <ul>
        <li>
          осуществление защиты персональных данных Оператором от неправомерного или случайного
          доступа;
        </li>
        <li>полную информацию об их персональных данных, обрабатываемых Оператором;</li>
        <li>
          доступ к своим персональным данным, включая право на получение копии любой записи,
          содержащей их персональные данные, за исключением случаев, предусмотренных федеральным
          законом;
        </li>
        <li>
          изменение, уточнение своих персональных данных, их блокирование или уничтожение в случае,
          если персональные данные являются неполными, устаревшими, неточными, незаконно полученными
          или не являются необходимыми для заявленной цели обработки;
        </li>
        <li>отзыв согласия на обработку персональных данных;</li>
        <li>принятие предусмотренных законом мер по защите своих прав;</li>
        <li>
          обжалование действия или бездействия Оператора, осуществляемого с нарушением требований
          законодательства РФ в области защиты персональных данных, в уполномоченный орган по защите
          прав субъектов персональных данных или в суд;
        </li>
        <li>осуществление иных прав, предусмотренных законодательством РФ.</li>
      </ul>

      <h3 className="fw-bold mt-4">10. Трансграничная передача персональных данных</h3>
      <p>
        10.1. Оператор до начала осуществления трансграничной передачи персональных данных обязан
        убедиться в том, что иностранным государством, на территорию которого предполагается
        осуществлять передачу персональных данных, обеспечивается надежная защита прав субъектов
        персональных данных.
      </p>
      <p>
        10.2. Трансграничная передача персональных данных на территории иностранных государств, не
        отвечающих вышеуказанным требованиям, может осуществляться только в случае наличия согласия
        в письменной форме субъекта персональных данных на трансграничную передачу его персональных
        данных и/или исполнения договора, стороной которого является субъект персональных данных.
      </p>

      <h3 className="fw-bold mt-4">
        11. Ответы на запросы субъектов на доступ к персональным данным
      </h3>
      <p>
        11.1. Подтверждение факта обработки персональных данных Оператором, правовые основания и
        цели обработки персональных данных, а также иные сведения, указанные в части 7 статьи 14
        Закона о персональных данных, предоставляются Оператором субъекту персональных данных или
        его представителю при обращении либо при получении запроса субъекта персональных данных или
        его представителя.
      </p>
      <p>
        В предоставляемые сведения не включаются персональные данные, относящиеся к другим субъектам
        персональных данных, за исключением случаев, когда имеются законные основания для раскрытия
        таких персональных данных.
      </p>
      <p>Запрос должен содержать:</p>
      <ul>
        <li>
          номер основного документа, удостоверяющего личность субъекта персональных данных или его
          представителя, сведения о дате выдачи указанного документа и выдавшем его органе;
        </li>
        <li>
          сведения, подтверждающие участие субъекта персональных данных в отношениях с Оператором
          (номер договора, дата заключения договора, условное словесное обозначение и (или) иные
          сведения), либо сведения, иным образом подтверждающие факт обработки персональных данных
          Оператором;
        </li>
        <li>подпись субъекта персональных данных или его представителя.</li>
      </ul>
      <p>
        Запрос может быть направлен в форме электронного документа и подписан электронной подписью в
        соответствии с законодательством Российской Федерации.
      </p>
      <p>
        Если в обращении (запросе) субъекта персональных данных не отражены в соответствии с
        требованиями Закона о персональных данных все необходимые сведения или субъект не обладает
        правами доступа к запрашиваемой информации, то ему направляется мотивированный отказ.
      </p>
      <p>
        Право субъекта персональных данных на доступ к его персональным данным может быть ограничено
        в соответствии с частью 8 статьи 14 Закона о персональных данных, в том числе если доступ
        субъекта персональных данных к его персональным данным нарушает права и законные интересы
        третьих лиц.
      </p>

      <h3 className="fw-bold mt-4">12. Порядок уничтожения, блокирования персональных данных</h3>
      <p>
        11.1. В случае выявления неправомерной обработки персональных данных при обращении субъекта
        персональных данных Оператор осуществляет блокирование неправомерно обрабатываемых
        персональных данных, относящихся к этому субъекту персональных данных, с момента такого
        обращения.
      </p>
      <p>
        12.2. В случае выявления неточных персональных данных при обращении субъекта персональных
        данных Оператор осуществляет блокирование персональных данных, относящихся к этому субъекту
        персональных данных, с момента такого обращения, если блокирование персональных данных не
        нарушает права и законные интересы субъекта персональных данных или третьих лиц.
      </p>
      <p>
        12.3. В случае подтверждения факта неточности персональных данных на основании сведений,
        представленных субъектом персональных данных, или иных необходимых документов Оператор
        уточняет персональные данные в течение 7 (семи) рабочих дней со дня представления таких
        сведений.
      </p>
      <p>
        12.4. В случае выявления неправомерной обработки персональных данных, осуществляемой
        Оператором, Оператор в срок, не превышающий 3 (трех) рабочих дней с даты этого выявления,
        прекращает неправомерную обработку персональных данных.
      </p>
      <p>
        12.5. Если обеспечить правомерность обработки персональных данных невозможно, Оператор в
        срок, не превышающий 10 (десяти) рабочих дней с даты выявления неправомерной обработки
        персональных данных, обязан уничтожить такие персональные данные.
      </p>
      <p>
        12.6. Об устранении допущенных нарушений или об уничтожении персональных данных Оператор
        обязан уведомить субъекта персональных данных.
      </p>
      <p>
        12.7. В случае достижения цели обработки персональных данных Оператор обязан прекратить
        обработку персональных данных и уничтожить персональные данные в срок, не превышающий 30
        (тридцати) дней с даты достижения цели обработки персональных данных.
      </p>
      <p>
        12.8. В случае отзыва субъектом персональных данных согласия на обработку его персональных
        данных Оператор прекращает их обработку и в случае, если сохранение персональных данных
        более не требуется для целей обработки персональных данных, уничтожает персональные данные в
        срок, не превышающий 30 (тридцати) дней с даты поступления указанного отзыва.
      </p>

      <h3 className="fw-bold mt-4">13. Заключительные положения</h3>
      <p>
        13.1. Пользователь может получить любые разъяснения по интересующим вопросам, касающимся
        обработки его персональных данных, обратившись к Оператору с помощью электронной почты:{' '}
        <a href="mailto:info@labcosmetic.ru">info@labcosmetic.ru</a>
      </p>
      <p>
        13.2. В данном документе будут отражены любые изменения Политики. Политика действует
        бессрочно до замены ее новой версией. Новая редакция Политики вступает в силу со дня ее
        размещения в CRM-системе KANE https://kanepro.ru/.
      </p>
    </div>
  )
}

export default Privacy
